const ColumnNames = {
  name: 'Name',
  adminEmail: 'Admin Email',
  repoCount: 'Repo Count',
  teamsCount: 'Teams',
  membersCount: 'Members',
  robotsCount: 'Robots',
  lastModified: 'Last Modified',
  size: 'Size',
  options: 'Settings',
};

export default ColumnNames;
